import {
  deliveryMenu,
  expressBasicMenu,
  favoriteAddressMenu,
  massiveMenu,
  paymentsMenu,
  sameNextDayMenu,
  receiptsMenu,
  dashboardMenu,
  historicalMenu,
} from 'src/app/components/shared/sharedConstants/menu.constants';
import { countries, sharedConstants, ui, kushki } from './constants';
import { enviromentParams as params } from './params';

const constants = {
  ...countries,
  ...ui,
  kushki,
  guardClause: null,
  shared: { ...sharedConstants, enableAllPermissions: false },
  listofmenu: [
    dashboardMenu,
    historicalMenu,
    deliveryMenu,
    expressBasicMenu,
    sameNextDayMenu,
    massiveMenu,
    paymentsMenu,
    favoriteAddressMenu,
    receiptsMenu,
  ],
};

export const environment = {
  environmentName: 'prod',
  production: true,
  hostname: 'https://mu-system-proxy.murbanos.co',
  hostnameApi: 'https://cerberus.mensajerosurbanos.com',
  hostnameMassive: 'https://mu-platform.murbanos.co',
  hostnameSndBFF: 'https://bff-snd.murbanos.co',
  hostMobile: 'https://bff-mobile.mensajerosurbanos.com',
  hostBffDashboard: 'https://bff-dashboard.mensajerosurbanos.com',
  hostTraceability: '/snd/traceability/package/',
  hostFailed: '/snd/traceability/failed-attends/',
  hostTrackStatusList: '/snd/traceability/tracking/package/',
  hostMassivePort: '',
  hostMassivePortUpload: '',
  hostPort: '',
  nonTrackingDomain: 'empresas.mensajerosurbanos.com',
  clientId: params.clientId,
  clientSecret: params.clientSecret,
  hostfintech: 'https://bff-fintech.murbanos.co',
  hostInternal: 'https://bff-company.mensajerosurbanos.com',
  hostBffInternal: 'https://bff-internal-services.murbanos.co',
  hostTimelineApi: 'https://bff-plataforma-unificada.mensajerosurbanos.com',
  chat: {
    widgetBaseUrl: 'https://pqrs.mensajerosurbanos.com/chat-widget/',
    slug: 'plataforma',
    width: 376,
    height: 540,
  },
  helpLink: 'https://pqrs.mensajerosurbanos.com/centro-de-ayuda/',
  testLoginEmail: '',
  testLoginPassword: '',
  webSocketUrl: 'wss://j0jc4wxwjd.execute-api.us-west-2.amazonaws.com/prod',
  webSocketFrontUrl: 'wss://realtime.mensajerosurbanos.com/socket_front?access_token=',
  webSocketTaskPerCompanyUrl:
    'wss://realtime.mensajerosurbanos.com/socket_tasks_per_company?access_token=bdf81c2238b312e1275ba331f9fb876dcbab75ff',
  webSocketAdminCourierUrl:
    'wss://realtime.mensajerosurbanos.com/socket_admin_all_couriers?token=1a425d05337e9513683eec390f8e2ceb31e33da198b3a573721356b52271cb8616567c5ae6faeed99ad8069f7d492939',
  webSocketClientVersion: 1,
  cancellationLinkCO: 'https://mensajerosurbanos.com/terminos-y-condiciones-cliente/',
  cancellationLinkMX: 'https://mensajerosurbanos.com/terminos-y-condiciones-usuario/?lang=mx',
  principalMULink: 'https://www.mensajerosurbanos.com/',
  kushkiInTest: false,
  googleAnalyticsId: 'G-HNR7522M5Y',
  timeVerifyVersion: 180000,
  timeReloadPointsUser: 1200000,
  publicDeliveryTrackShortLink: 'https://tinyurl.com/2p98vvae/',
  FacebookPixelId: '464174501873804',
  featureFlags: {
    dashboardMpay: true,
  },
  ...constants,
};
